/** Arabic-Indic (٠-٩) and Persian (۰-۹) digits → 0-9, as some keyboards type them. */
export function toWesternDigits(text: string): string {
  return text.replace(/[٠-٩۰-۹]/g, (d) => {
    const code = d.charCodeAt(0);
    return String(code >= 0x06f0 ? code - 0x06f0 : code - 0x0660);
  });
}

/**
 * Loose Arabic matching for typed searches: drops diacritics and tatweel and
 * folds letter variants (أ إ آ → ا, ة → ه, ى → ي).
 */
export function normalizeArabic(text: string): string {
  return toWesternDigits(text)
    .toLowerCase()
    .replace(/[ً-ْٰـ]/g, '')
    .replace(/[أإآٱ]/g, 'ا')
    .replace(/ة/g, 'ه')
    .replace(/ى/g, 'ي')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Every word of `query` appears somewhere in `fields`, in any order. */
export function matchesWords(
  fields: (string | null | undefined)[],
  query: string,
): boolean {
  const q = normalizeArabic(query);
  if (!q) return true;
  const haystack = normalizeArabic(fields.filter(Boolean).join(' '));
  return q.split(' ').every((word) => haystack.includes(word));
}
